export default {
  "nav": {
    "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accueil"])},
    "aquariums": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aquariums"])},
    "plants": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plantes"])},
    "profile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profil"])}
  },
  "login": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connexion"])},
    "username": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom d'utilisateur"])},
    "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mot de passe"])},
    "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se connecter"])},
    "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identifiant ou mot de passe incorrect"])}
  },
  "home": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accueil"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bon retour"])},
    "hello": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bonjour ! 👋"])},
    "welcome": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vos aquariums se portent bien."])},
    "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déconnexion"])},
    "quickAccess": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accès rapide"])}
  },
  "aquariums": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mes aquariums"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suivez vos bacs"])},
    "status": {
      "healthy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sain"])},
      "attention": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attention"])}
    }
  },
  "plants": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plantes"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Votre flore aquatique"])},
    "sections": {
      "foreground": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Premier plan"])},
      "midground": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plan intermédiaire"])},
      "background": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arrière-plan"])}
    }
  },
  "pwa": {
    "tagline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Votre compagnon aquariophile"])},
    "install": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Installer l'app"])},
    "loginCta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Installer AquaScaper sur votre appareil"])},
    "android": {
      "promptDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Installez AquaScaper sur votre écran d'accueil pour la meilleure expérience."])},
      "manualDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajoutez AquaScaper à votre écran d'accueil :"])},
      "step1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Appuyez sur le menu"])},
      "step2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Appuyez sur « Ajouter à l'écran d'accueil »"])},
      "step3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Appuyez sur « Ajouter » pour confirmer"])}
    },
    "ios": {
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajoutez AquaScaper à votre écran d'accueil :"])},
      "step1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Appuyez sur le bouton Partager"])},
      "step2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Appuyez sur « Sur l'écran d'accueil » puis « Ajouter »"])},
      "safariOnly": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fonctionne uniquement dans Safari sur iOS"])}
    },
    "desktop": {
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AquaScaper est conçu pour mobile."])},
      "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouvrez cette page sur votre téléphone ou tablette pour l'installer sur votre écran d'accueil."])}
    }
  },
  "profile": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profil"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte & paramètres"])},
    "memberSince": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Membre depuis"])},
    "settings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres"])},
    "items": {
      "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notifications"])},
      "language": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Langue"])},
      "units": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unités"])},
      "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["À propos d'AquaScaper"])}
    }
  }
}